export default {
  "unableToLoadOutlets": "Unable to load outlets",
  "unableToLoadDiningAreas": "Unable to load dining areas",
  "unableToLoadTables": "Unable to load tables",
  "unableToLoadFloorPlan": "Unable to load floor plan",
  "couldNotUploadDiningImage": "Could not upload dining image",
  "diningImageSaved": "Dining image saved",
  "thePreviewIsTemporarilyUnavailableItWillAppearAutomaticallyWhenImageDeliveryRecovers": "The preview is temporarily unavailable. It will appear automatically when image delivery recovers.",
  "unableToSaveArea": "Unable to save area",
  "chooseASupportedImage": "Choose a supported image",
  "diningImageRemoved": "Dining image removed",
  "theChangeWasSavedButThePreviewServiceIsTemporarilyUnavailable": "The change was saved, but the preview service is temporarily unavailable.",
  "unableToRemoveImage": "Unable to remove image",
  "unableToDeactivateArea": "Unable to deactivate area",
  "cancellationPolicySaved": "Cancellation policy saved",
  "unableToSaveTable": "Unable to save table",
  "qRDownloadReady": "QR download ready",
  "yourPrivanaDiningQRFileHasBeenGenerated": "Your Privana Dining QR file has been generated.",
  "unableToGenerateQR": "Unable to generate QR",
  "unableToLoadQRPreview": "Unable to load QR preview",
  "thePublicQRURLHasBeenCopied": "The public QR URL has been copied.",
  "unableToDeactivateTable": "Unable to deactivate table",
  "unableToBulkAddTables": "Unable to bulk add tables",
  "floorPlanSaved": "Floor plan saved",
  "yourLayoutChairsWallsAndDoorsWereSaved": "Your layout, chairs, walls, and doors were saved.",
  "unableToSaveFloorPlan": "Unable to save floor plan",
  "openHostConsoleInANewTab": "Open Host Console in a new tab",
  "openHostConsole": "Open Host Console",
  "addArea": "Add area",
  "diningAreas": "Dining Areas",
  "manageSharedRoomSectionsIndependentlyFromPOSOutletAssignments": "Manage shared room sections independently from POS outlet assignments.",
  "loadingDiningAreas": "Loading dining areas…",
  "noDiningAreasYetCreateYourFirstAreaToBegin": "No dining areas yet. Create your first area to begin.",
  "sharedDiningServiceSpace": "Shared dining service space",
  "active": "Active",
  "inactive": "Inactive",
  "unableToUpdateArea": "Unable to update area",
  "generateAreaQR": "Generate Area QR",
  "cancellationPolicy": "Cancellation Policy",
  "edit": "Edit",
  "deactivate": "Deactivate",
  "tables": "Tables",
  "buildATableListForTheSelectedDiningArea": "Build a table list for the selected dining area.",
  "diningArea": "Dining area",
  "selectArea": "Select area",
  "generateTableQRs": "Generate Table QRs",
  "bulkAdd": "Bulk add",
  "addTable": "Add table",
  "loadingTables": "Loading tables…",
  "selectADiningAreaToViewTables": "Select a dining area to view tables.",
  "thisArea": "this area",
  "table": "Table",
  "capacity": "Capacity:",
  "unableToUpdateTable": "Unable to update table",
  "editDiningArea": "Edit Dining Area",
  "addDiningArea": "Add Dining Area",
  "areaName": "Area name",
  "restaurant": "Restaurant",
  "activeArea": "Active area",
  "enableOrDisableThisDiningArea": "Enable or disable this dining area.",
  "diningImage": "Dining image",
  "forBestResultsUseALandscapeImageAtLeast1600900pxJPEGPNGOrWebPUpTo5MB": "For best results, use a landscape image at least 1600 × 900px. JPEG, PNG or WebP, up to 5 MB.",
  "diningAreaPreview": "Dining area preview",
  "previewUnavailableYourImageIsStillSaved": "Preview unavailable — your image is still saved",
  "addAWelcomingDiningHero": "Add a welcoming dining hero",
  "replaceImage": "Replace image",
  "uploadImage": "Upload image",
  "removeImage": "Remove image",
  "altTextOptional": "Alt text (optional)",
  "candlelitTerraceOverlookingTheGarden": "Candlelit terrace overlooking the garden",
  "horizontalFocus": "Horizontal focus",
  "verticalFocus": "Vertical focus",
  "securelySavingDiningArea": "Securely saving dining area…",
  "cancel": "Cancel",
  "saving": "Saving…",
  "saveArea": "Save area",
  "thisDiningArea": "this dining area",
  "minimumNoticeHoursBeforeReservationStart": "Minimum notice hours before reservation start",
  "removeDiningImage": "Remove dining image?",
  "membersWillSeeYourClubHeroOrPrivanaSDiningFallbackInsteadThisCannotBeUndone": "Members will see your club hero or Privana’s dining fallback instead. This cannot be undone.",
  "keepImage": "Keep image",
  "removing": "Removing…",
  "editTable": "Edit Table",
  "addTableLabel": "Add Table",
  "label": "Label",
  "table12": "Table 12",
  "capacityLabel": "Capacity",
  "activeTable": "Active table",
  "deactivateToHideThisTableOnPOS": "Deactivate to hide this table on POS.",
  "saveTable": "Save table",
  "bulkAddTables": "Bulk add tables",
  "startNumber": "Start number",
  "endNumber": "End number",
  "prefixOptional": "Prefix (optional)",
  "capacityOptional": "Capacity (optional)",
  "createTables": "Create tables",
  "fileType": "File type",
  "previewQRCode": "Preview QR code",
  "previewTableQRCodes": "Preview table QR codes",
  "loadingQRPreview": "Loading QR preview…",
  "areaQRPreview": "Area QR preview",
  "openLink": "Open link",
  "copyURL": "Copy URL",
  "open": "Open",
  "copy": "Copy",
  "generating": "Generating…",
  "generateDownload": "Generate / Download",
  "checkIn": "Check In",
  "seat": "Seat",
  "complete": "Complete",
  "confirm": "Confirm",
  "staff": "Staff",
  "membersPortal": "Members Portal",
  "membersApp": "Members App",
  "guest": "Guest",
  "walkIn": "Walk-in",
  "accessDenied": "Access denied.",
  "unableToLoadDiningReservations": "Unable to load dining reservations.",
  "today": "Today",
  "tomorrow": "Tomorrow",
  "future": "Future",
  "functions": "Functions",
  "createReservation": "Create Reservation",
  "addWalkIn": "Add Walk-In",
  "viewPastBookings": "View Past Bookings",
  "manageTableBlocks": "Manage Table Blocks",
  "retry": "Retry",
  "dismiss": "Dismiss",
  "notesOrAllergyInformation": "Notes or allergy information",
  "noReservations": "No reservations",
  "reservation": "Reservation",
  "date": "Date",
  "time": "Time",
  "partySize": "Party size",
  "duration": "Duration",
  "memberNotes": "Member notes",
  "staffNotes": "Staff notes",
  "reasonForCancelNoShow": "Reason for cancel / no-show",
  "saveChanges": "Save changes",
  "reject": "Reject",
  "noShow": "No Show",
  "reservationType": "Reservation type",
  "existingMember": "Existing member",
  "memberSearch": "Member search",
  "searchMember": "Search member",
  "guestName": "Guest name",
  "email": "Email",
  "phone": "Phone",
  "tableOptional": "Table (optional)",
  "createReservationLabel": "Create reservation",
  "pastBookings": "Past Bookings",
  "memberGuestOrReference": "Member, guest or reference",
  "allStatuses": "All statuses",
  "allAreas": "All areas",
  "search": "Search",
  "previous": "Previous",
  "of": "of",
  "next": "Next",
  "reason": "Reason",
  "saveBlock": "Save block",
  "addBlock": "Add block",
  "delete": "Delete",
  "deleteTableBlock": "Delete table block?",
  "thisWillReturnTheTableToAvailabilityForTheBlockedPeriod": "This will return the table to availability for the blocked period.",
  "keepBlock": "Keep block",
  "deleteBlock": "Delete block",
  "autoAssign": "Auto assign",
  "sunday": "Sunday",
  "monday": "Monday",
  "tuesday": "Tuesday",
  "wednesday": "Wednesday",
  "thursday": "Thursday",
  "friday": "Friday",
  "saturday": "Saturday",
  "addAtLeastOneServiceWindow": "Add at least one service window.",
  "minimumPartySizeCannotExceedMaximumPartySize": "Minimum party size cannot exceed maximum party size.",
  "reservations": "Reservations",
  "configureMemberAndGuestBookingAvailability": "Configure member and guest booking availability.",
  "reservationDays": "Reservation days",
  "serviceWindows": "Service windows",
  "addWindow": "Add window",
  "windowStart": "Window start",
  "windowEnd": "Window end",
  "removeServiceWindow": "Remove service window",
  "bookingIntervalMinutes": "Booking interval (minutes)",
  "defaultDurationMinutes": "Default duration (minutes)",
  "minimumPartySize": "Minimum party size",
  "maximumPartySize": "Maximum party size",
  "maximumDaysAhead": "Maximum days ahead",
  "minimumNoticeMinutes": "Minimum notice (minutes)",
  "cancellationWindowMinutes": "Cancellation window (minutes)",
  "requireStaffApproval": "Require staff approval",
  "allowGuestReservations": "Allow guest reservations",
  "allowWalkIns": "Allow walk-ins",
  "small": "Small",
  "medium": "Medium",
  "large": "Large",
  "general": "General",
  "mainDining": "Main Dining",
  "windowSeating": "Window Seating",
  "privateDining": "Private Dining",
  "bar": "Bar",
  "patio": "Patio",
  "terrace": "Terrace",
  "event": "Event",
  "lounge": "Lounge",
  "quietArea": "Quiet Area",
  "familyArea": "Family Area",
  "highTop": "High Top",
  "staffOnly": "Staff Only",
  "custom": "Custom",
  "round2": "Round 2",
  "roundTables": "Round tables",
  "round4": "Round 4",
  "round6": "Round 6",
  "round8": "Round 8",
  "square2": "Square 2",
  "squareTables": "Square tables",
  "square4": "Square 4",
  "rectangle4": "Rectangle 4",
  "rectangleTables": "Rectangle tables",
  "rectangle6": "Rectangle 6",
  "rectangle8": "Rectangle 8",
  "rectangle10": "Rectangle 10",
  "ovalBanquet": "Oval / banquet",
  "specialSeating": "Special seating",
  "booth": "Booth",
  "barCounter": "Bar / counter",
  "serviceStation": "Service station",
  "operations": "Operations",
  "diningZone": "Dining zone",
  "object": "Object",
  "wallPath": "Wall path",
  "door": "Door",
  "floorPlanImage": "Floor plan image",
  "selectionHandle": "Selection handle",
  "dining": "Dining",
  "floorPlanBuilder": "Floor plan builder",
  "dragTablesDrawWallsToggleIndividualChairsAndSaveAClubScopedLayout": "Drag tables, draw walls, toggle individual chairs, and save a club-scoped layout.",
  "selectDiningArea": "Select dining area",
  "selectAnArea": "Select an area",
  "reload": "Reload",
  "save": "Save",
  "duplicateTableLinksWereRepairedReviewUnlinkedTablesBeforeSaving": "Duplicate table links were repaired. Review unlinked tables before saving.",
  "chooseADiningAreaToStart": "Choose a dining area to start",
  "theBuilderWillKeepEachLayoutScopedToTheCurrentClubAndSelectedArea": "The builder will keep each layout scoped to the current club and selected area.",
  "palette": "Palette",
  "clickOrDragOntoTheCanvas": "Click or drag onto the canvas.",
  "select": "Select",
  "wall": "Wall",
  "zone": "Zone",
  "ops": "Ops",
  "clickMoreWallPointsDoubleClickToFinishOrClickTheFirstPointToClose": "Click more wall points. Double-click to finish, or click the first point to close.",
  "clickTheWallStartPoint": "Click the wall start point.",
  "clickMoreZonePointsDoubleClickToFinishOrClickTheFirstPointToClose": "Click more zone points. Double-click to finish, or click the first point to close.",
  "clickTheFirstZonePoint": "Click the first zone point.",
  "dragToMoveItemsShiftClickToSelectMultiple": "Drag to move items. Shift-click to select multiple.",
  "canvasSize": "Canvas size",
  "tracingMode": "Tracing mode",
  "showZones": "Show zones",
  "zoneLegend": "Zone legend",
  "legend": "Legend",
  "keyboardShortcuts": "Keyboard shortcuts",
  "wallTool": "Wall tool",
  "zoneTool": "Zone tool",
  "selectOrCancel": "Select or cancel",
  "deleteSelected": "Delete selected",
  "duplicate": "Duplicate",
  "undo": "Undo",
  "redo": "Redo",
  "rotate15": "Rotate 15°",
  "arrows": "Arrows",
  "nudgeShift5x": "Nudge (Shift = 5x)",
  "deleteObjects": "Delete objects",
  "exitFullScreen": "Exit full screen",
  "fullScreen": "Full screen",
  "loadingFloorPlan": "Loading floor plan…",
  "uploadAFloorPlanImageAlignItLockItThenTraceWallsOverTheTop": "Upload a floor plan image, align it, lock it, then trace walls over the top.",
  "hideTracingMode": "Hide tracing mode",
  "unlockImage": "Unlock image",
  "lockImage": "Lock image",
  "showBackgroundImage": "Show background image",
  "opacity": "Opacity",
  "tracingImageOpacity": "Tracing image opacity",
  "rotation": "Rotation",
  "tracingImageRotation": "Tracing image rotation",
  "width": "Width",
  "tracingImageWidth": "Tracing image width",
  "height": "Height",
  "tracingImageHeight": "Tracing image height",
  "rotateLeft": "Rotate left",
  "rotateRight": "Rotate right",
  "fitImageToCanvas": "Fit image to canvas",
  "clearImage": "Clear image",
  "pNGJPGJPEGAndWebPFilesAreSavedLocallyInTheFloorPlanLayoutJSONForNow": "PNG, JPG, JPEG, and WebP files are saved locally in the floor plan layout JSON for now.",
  "startWithAPolishedEmptyPlan": "Start with a polished empty plan",
  "addATableFromThePaletteDrawAWallOrDropInADoorEverythingSnapsToTheGrid": "Add a table from the palette, draw a wall, or drop in a door. Everything snaps to the grid.",
  "seats": "seats",
  "pressEscToExitFullScreen": "Press Esc to exit full screen",
  "rotateHandle": "Rotate handle",
  "service": "Service",
  "inspector": "Inspector",
  "multipleSelected": "Multiple selected",
  "selectAnItemToEditDetails": "Select an item to edit details.",
  "useTheLeftPaletteToAddWallsDoorsTablesBoothsBarsAndServiceStations": "Use the left palette to add walls, doors, tables, booths, bars, and service stations.",
  "chairsAreChildrenOfTableTemplatesClickAChairOnTheCanvasToDisableOrEnableThatSeat": "Chairs are children of table templates. Click a chair on the canvas to disable or enable that seat.",
  "doorOpening": "Door / opening",
  "tableObject": "Table object",
  "nameLabel": "Name / label",
  "zoneType": "Zone Type",
  "zoneTypeLabel": "Zone type",
  "color": "Color",
  "zoneColor": "Zone color",
  "zoneColorValue": "Zone color value",
  "zoneCapacity": "Zone capacity",
  "activeTableSeats": "Active table seats",
  "tablesInZone": "Tables in zone",
  "activeTables": "Active tables",
  "totalSeats": "Total seats",
  "includesInactiveTables": "Includes inactive tables",
  "layerPosition": "Layer position",
  "layer": "Layer",
  "showZone": "Show zone",
  "hiddenZonesAreNotShownButCanStillAssignReport": "Hidden zones are not shown but can still assign/report.",
  "bringForward": "Bring forward",
  "sendBackward": "Send backward",
  "bringToFront": "Bring to front",
  "sendToBack": "Send to back",
  "cloneZone": "Clone zone",
  "tableNumber": "Table number",
  "linkedDiningTable": "Linked dining table",
  "createOrLinkTable": "Create or link table",
  "createNewOnSave": "Create new on save",
  "linkedDiningTableLabel": "Linked Dining Table",
  "sourceOfTruth": "Source of truth:",
  "noArea": "No area",
  "outlet": "Outlet",
  "noOutlet": "No outlet",
  "capacityComesFromTheLinkedDiningTableSourceOfTruth": "Capacity comes from the linked dining table source of truth.",
  "capacityIsControlledByEnabledChairObjects": "Capacity is controlled by enabled chair objects.",
  "points": "Points",
  "edges": "Edges",
  "segments": "Segments",
  "inactiveZonesDoNotAssignReport": "Inactive zones do not assign/report.",
  "inactiveObjectsAreFadedOnThePlan": "Inactive objects are faded on the plan.",
  "deleteZone": "Delete zone",
  "deleteItem": "Delete item",
  "diningHostConsole": "Dining Host Console",
  "thePublishedFloorCouldNotBeDisplayed": "The published floor could not be displayed.",
  "reservationsAndServiceDataAreStillAvailable": "Reservations and service data are still available.",
  "refreshingFloor": "Refreshing floor…",
  "retryFloor": "Retry floor",
  "publishedDiningFloorPlan": "Published dining floor plan",
  "interactiveDiningFloorDragToMoveUseTheMouseWheelOrPinchGestureToZoom": "Interactive dining floor. Drag to move. Use the mouse wheel or pinch gesture to zoom.",
  "zoomOut": "Zoom out",
  "fitFloor": "Fit floor",
  "zoomIn": "Zoom in",
  "guestParty": "Guest party",
  "authenticatedStaff": "Authenticated staff",
  "floor": "Floor",
  "unableToPrepareDiningOperations": "Unable to prepare Dining operations.",
  "unableToRefreshDiningOperations": "Unable to refresh Dining operations.",
  "thisReservationChangedOnAnotherDeviceTheLatestDetailsHaveBeenLoaded": "This reservation changed on another device. The latest details have been loaded.",
  "actionFailed": "Action failed.",
  "waitlist": "Waitlist",
  "arrived": "Arrived",
  "seated": "Seated",
  "available": "Available",
  "late": "Late",
  "noShows": "No shows",
  "weCouldnTLogYouOutPleaseTryAgain": "We couldn't log you out. Please try again.",
  "noDiningAreasConfigured": "No dining areas configured",
  "covers": "covers",
  "signOut": "Sign out",
  "hostConsole": "Host console",
  "todaySOperationalSummary": "Today’s operational summary",
  "preparingTodaySFloorAndReservations": "Preparing today’s floor and reservations…",
  "liveFloor": "Live Floor",
  "refreshing": "Refreshing",
  "noActiveDiningAreasAreConfigured": "No active Dining areas are configured",
  "noActiveDiningTablesAreConfigured": "No active dining tables are configured",
  "noPublishedFloorPlanIsAvailableForThisArea": "No published floor plan is available for this area",
  "markThisReservationAsNoShow": "Mark this reservation as no-show?",
  "completeThisDiningVisit": "Complete this dining visit?",
  "comingNextThisPhaseKeepsFocusOnLiveFloorAndReservationOperations": "Coming next. This phase keeps focus on live floor and reservation operations.",
  "servicePulse": "Service pulse",
  "noReservationsForToday": "No reservations for today",
  "activeReservations": "Active reservations",
  "unassigned": "Unassigned",
  "noReservationsForThisDate": "No reservations for this date",
  "next45Days": "Next 45 days",
  "futureReservations": "Future reservations",
  "noFutureReservations": "No future reservations",
  "markArrived": "Mark arrived",
  "runningLate": "Running late",
  "assignTable": "Assign table",
  "noShowLabel": "No-show",
  "seatParty": "Seat party",
  "seatAssignTable": "Seat / assign table",
  "changeTable": "Change table",
  "completeVisit": "Complete visit",
  "close": "Close",
  "member": "Member",
  "status": {
    "pending": "pending",
    "confirmed": "confirmed",
    "checked_in": "checked in",
    "seated": "seated",
    "completed": "completed",
    "cancelled": "cancelled",
    "no_show": "no show",
    "available": "available",
    "assigned": "assigned",
    "reserved_soon": "reserved soon",
    "arrived": "arrived",
    "blocked": "blocked",
    "inactive": "inactive"
  },
  "party": "Party",
  "notesAllergyIndicators": "Notes / allergy indicators",
  "viewOnlyDiningBookingsAccess": "View-only Dining Bookings access",
  "upcomingAssigned": "Upcoming / assigned",
  "noUpcomingReservationsAssignedToThisTable": "No upcoming reservations assigned to this table.",
  "invalidClubRoute": "Invalid club route",
  "useACanonicalSixDigitClubCode": "Use a canonical six-digit club code.",
  "accessDeniedLabel": "Access denied",
  "unableToLoadHostConsole": "Unable to load Host Console",
  "privanaCouldNotCompleteClubResolutionOrAuthorisationPleaseRetry": "Privana could not complete club resolution or authorisation. Please retry.",
  "signingYouOut": "Signing you out…",
  "enterAClubRoute": "Enter a club route",
  "open123001ToStartDiningHostConsole": "Open /123001 to start Dining Host Console.",
  "deactivateArea": "Deactivate {name}?",
  "deactivateTable": "Deactivate table {label}?",
  "cancellationDescription": "Configure member cancellation for {name}.",
  "noTablesForArea": "No tables yet. Add tables for {name}.",
  "areaQrSummary": "Generating one area QR for {name}.",
  "tableQrSummary": "Generating table QRs for {name} ({count} active tables).",
  "tableQrSummaryOne": "Generating table QRs for {name} ({count} active tables).",
  "qrPreview": "{label} QR preview",
  "urlCopied": "URL copied",
  "reservationReference": "Reservation {reference}",
  "areaTable": "{area} · Table {table}",
  "tableLabel": "Table {label}",
  "pagination": "{from}–{to} of {total}",
  "validWindow": "Enter a valid start and end time for {day}.",
  "overlappingWindows": "{day} service windows cannot overlap.",
  "selectedObjects": "{count} objects selected. Drag any selected object to move the group, or use keyboard shortcuts for duplicate, delete, and nudge.",
  "linkedTableSummary": "Source of truth: {label} · {capacity} seats · {status}.",
  "resizeHandle": "Resize {handle}",
  "zonePointHandle": "Zone point {number} handle",
  "wallPointHandle": "Wall point {number} handle",
  "tableState": "Table {label}, {status}",
  "signOutStaff": "Sign out {name}",
  "coverCountOne": "{count} covers",
  "coverCountOther": "{count} covers",
  "activeCount": "{count} active",
  "publishedLayout": "Published layout · {name}",
  "serviceSummary": "{waiting} waiting · {seated} seated · {available} tables available · {completed} completed.",
  "lateStatus": "{status} · Late",
  "dateReservations": "{date} reservations",
  "upcomingSummary": "{time} · {count} guests · {status}",
  "unauthorisedClub": "Your account is not authorised for Dining Host Console access to club {clubCode}.",
  "selectDate": "Select date",
  "chooseServiceDate": "Choose service date",
  "serviceDate": "Service date",
  "unknownStatus": "Unknown status",
  "unknownSource": "Unknown source",
  "genericError": "Unable to complete the dining request. Please try again.",
  "requestReference": "{message} (Request ID: {requestId})",
  "authRestoring": "restoring… session",
  "authAuthenticating": "authenticating",
  "authResolving": "resolving… club",
  "authAuthorising": "authorising",
  "authLoading": "loading",
  "topLeft": "top left",
  "topRight": "top right",
  "bottomLeft": "bottom left",
  "bottomRight": "bottom right",
  "source": {
    "staff": "Staff",
    "member_portal": "Members Portal",
    "members_mobile": "Members App",
    "guest": "Guest",
    "walk_in": "Walk-in"
  },
  "errors": {
    "slot_unavailable": "The selected table or time is no longer available.",
    "party_size_out_of_range": "The party size is outside the permitted range.",
    "invalid_party_size": "Enter a valid party size.",
    "invalid_guest_name": "Enter a guest name.",
    "invalid_guest_email": "Enter a valid guest email address.",
    "invalid_guest_phone": "Enter a valid guest phone number.",
    "invalid_member_id": "Select a valid member.",
    "member_not_found": "The member could not be found.",
    "area_not_found": "The dining area could not be found.",
    "table_not_found": "The table could not be found.",
    "reservation_not_found": "The reservation could not be found.",
    "reservation_terminal": "This reservation can no longer be changed.",
    "invalid_status_transition": "This status change is not permitted.",
    "reason_required": "Enter a reason for this action.",
    "invalid_local_datetime": "Enter a valid reservation date and time.",
    "invalid_local_time": "This local time is not valid in the club timezone.",
    "ambiguous_local_time": "This time occurs twice when the clocks change. Choose another time.",
    "invalid_duration": "Enter a valid duration.",
    "duration_not_permitted": "This duration is not permitted.",
    "minimum_notice_not_met": "The minimum booking notice has not been met.",
    "outside_service_window": "The reservation is outside the service windows.",
    "booking_interval_mismatch": "Choose a time that matches the booking interval.",
    "reservation_day_unavailable": "Reservations are unavailable on this service day.",
    "reservation_date_out_of_range": "The reservation date is outside the permitted range.",
    "reservations_unavailable": "Reservations are unavailable for this dining area.",
    "walk_ins_disabled": "Walk-ins are disabled for this dining area.",
    "guest_reservations_disabled": "Guest reservations are disabled for this dining area.",
    "table_block_conflicts_with_reservation": "The table block conflicts with a reservation.",
    "block_not_found": "The table block could not be found.",
    "invalid_table_block": "Enter a valid table block.",
    "invalid_date_filter": "Enter a valid date filter.",
    "invalid_range": "Enter a valid number range.",
    "rate_limited": "Too many requests. Please try again shortly.",
    "invalid_upload": "Select an image to upload.",
    "invalid_image_type": "Upload a valid JPEG, PNG or WebP image.",
    "malformed_image": "The image is corrupt, truncated, or could not be decoded.",
    "image_too_large": "Images must be 5 MB or less.",
    "service_windows_required": "Add at least one service window.",
    "overlapping_service_windows": "Service windows cannot overlap.",
    "invalid_reservation_settings": "Check the reservation settings.",
    "invalid_party_size_range": "Minimum party size cannot exceed maximum party size.",
    "invalid_reservation_time_increment": "Booking intervals and durations must use five-minute increments.",
    "invalid_booking_interval": "Enter a booking interval between 5 and 240 minutes.",
    "invalid_default_duration": "Enter a default duration between 15 and 720 minutes.",
    "invalid_minimum_party_size": "Enter a minimum party size between 1 and 100.",
    "invalid_maximum_party_size": "Enter a maximum party size between 1 and 500.",
    "invalid_maximum_days_ahead": "Enter a booking horizon between 0 and 730 days.",
    "invalid_minimum_notice": "Enter a minimum notice between 0 and 10080 minutes.",
    "invalid_cancellation_window": "Enter a cancellation window between 0 and 43200 minutes.",
    "invalid_service_window_time": "Enter a valid service-window start and end time.",
    "invalid_service_window_day": "Select a valid service day.",
    "service_window_day_disabled": "Enable the reservation day before adding a service window.",
    "invalid_service_windows": "Check the service windows.",
    "invalid_service_window": "Check the service window.",
    "invalid_reservation_days": "Select valid reservation days.",
    "unknown_reservation_setting": "The reservation settings contain an unsupported option.",
    "invalid_area_id": "Select a valid dining area.",
    "invalid_table_id": "Select a valid table.",
    "table_not_in_area": "The selected table does not belong to this dining area.",
    "duplicate_linked_table": "Each active visual table can link to a dining table only once.",
    "linked_table_invalid": "The linked dining table is not valid.",
    "invalid_status": "Select a valid reservation status.",
    "invalid_booking_source": "Select a valid reservation source.",
    "invalid_search": "Enter a valid search.",
    "invalid_start_at": "Enter a valid reservation start time.",
    "invalid_reservation_id": "Select a valid reservation.",
    "floor_plan_not_found": "The floor plan could not be found.",
    "invalid_floor_plan_id": "Select a valid floor plan."
  },
  "vip": "VIP",
  "reservationCount": "{count} reservations",
  "logoutTitle": "Log out of Privana?",
  "logoutDescription": "Are you sure you want to log out?",
  "loggingOut": "Logging out…",
  "logOut": "Log out",
  "print": {
    "heading": "PRIVANA DINING",
    "instruction": "Scan to view the menu",
    "area": "Dining area QR",
    "table": "Table QR"
  },
  "reminder": {
    "title": "Dining reservation reminder",
    "body": "Your dining reservation {reference} is coming up."
  },
  "seatCount": "{count} seats",
  "partyStatus": "{count} guests · {status}",
  "guestCount": "{count} guests",
  "saved": "Changes saved.",
  "activeCountOne": "{count} active",
  "reservationCountOne": "{count} reservations",
  "seatCountOne": "{count} seats",
  "guestCountOne": "{count} guests",
  "partyStatusOne": "{count} guests · {status}",
  "linkedTableSummaryOne": "Source of truth: {label} · {capacity} seats · {status}.",
  "statusLabel": "Status",
  "layerSummary": "Layer {position} of {total}",
  "elapsedMinutes": "{count}m",
  "resizeCorner": {
    "nw": "nw",
    "ne": "ne",
    "se": "se",
    "sw": "sw"
  },
  "missingPolicyHandler": "Unable to save cancellation policy. Save handler is not configured."
};
